import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { injectIntl } from 'react-intl';
import { sendPinConfirmation, AuthState, getAuthState, clearAuthentalinkResendResponse } from 'actions';
import { getOnlineConfig } from 'actions/app';
import LocalisedMessage from 'components/Common/LocalisedMessage';
import { getCookie } from 'common/cookies';
import pinType from 'common/pinType';
import EnvConfig from 'env.config';

const AuthentaLinkPinConfirmation = ({ sendingConfirmation, confirmationMessage, confirmationStatus, resendReference, authState, dispatch, intl }) => {
  const [visible, setIsVisible] = useState(false);
  const [localResendReference, setLocalResendReference] = useState(getCookie(EnvConfig.autentaLinkResendName));

  useEffect(() => {
    if (!confirmationMessage) {
      setIsVisible(false);
      return;
    }
    setIsVisible(true);
    const timer = setTimeout(() => {
      setIsVisible(false);
      dispatch(clearAuthentalinkResendResponse());
    }, 5000);
    // eslint-disable-next-line no-return-assign, consistent-return
    return () => {
      clearTimeout(timer);
      dispatch(clearAuthentalinkResendResponse());
    };
  }, [confirmationMessage]);

  useEffect(() => {
    dispatch(getAuthState());
    if (authState === AuthState.Authorised) {
      dispatch(getOnlineConfig());
    }
    if (resendReference !== null) {
      document.cookie = `${ EnvConfig.autentaLinkResendName }=${ resendReference }; expires=${ new Date().getHours() + 1 }; samesite=lax`;
      setLocalResendReference(resendReference);
    }
  }, []);

  const resendPinConfirmation = () => {
    dispatch(sendPinConfirmation(pinType.NoEmailConfirmationPin, localResendReference));
  };

  const error = visible && <span className={ `pin-status ${ confirmationStatus ? 'success' : '' }` }>
    <FontAwesomeIcon icon={ `${ confirmationStatus ? 'check' : 'times' }` } />
    <span className="error-msg">{ confirmationMessage }</span>
    </span>;

  return (
    <div className="authentalink-verification">
      <div className="card mt-4 offset-1 col-10 offset-lg-2 col-lg-8 offset-xl-3 col-xl-6">
        <LocalisedMessage id="authentalink.pinConfirmation.title" />
        <p><LocalisedMessage id="noEmailConfirmation.Line.1" /></p>
        <p><LocalisedMessage id="noEmailConfirmation.Line.2" /></p>
        <p><LocalisedMessage id="noEmailConfirmation.Line.3" /></p>
        <p><LocalisedMessage id="noEmailConfirmation.Line.4" /></p>
        { localResendReference && <button
          className={ `btn btn-link ${ sendingConfirmation ? 'btn-active' : '' }` }
          type="button"
          onClick={ () => resendPinConfirmation() }
        >
          <strong> { !sendingConfirmation && `${ intl.formatMessage({ id: 'authentalink.pinConfirmation.ResendEmailText' }) }` }</strong>
        </button> }
        <div>{ error }</div>
      </div>
      <div className="offset-1 col-10 offset-lg-2 col-lg-8 offset-xl-3 col-xl-6 pr-0 protected-by-authentalink">
        <div className="powered-by text-right text-top">{ intl.formatMessage({ id: 'authentalink.confirmation.formFooter' }) } <div className="logo-nameonly" /> Authent-A-Link</div>
      </div>
    </div>
  );
};

AuthentaLinkPinConfirmation.propTypes = {
  dispatch: PropTypes.func.isRequired,
  authState: PropTypes.string,
  resendReference: PropTypes.number,
  sendingConfirmation: PropTypes.bool,
  confirmationMessage: PropTypes.string,
  confirmationStatus: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired
};

AuthentaLinkPinConfirmation.defaultProps = {
  authState: AuthState.Unknown,
  resendReference: null,
  sendingConfirmation: false,
  confirmationMessage: null,
  confirmationStatus: false
};

function mapStateToProps(state) {
  const {
    app: { authState },
    authentaLink: { sendingConfirmation, confirmationMessage, confirmationStatus, resendReference }
  } = state;

  return {
    authState,
    sendingConfirmation,
    confirmationMessage,
    confirmationStatus,
    resendReference
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(AuthentaLinkPinConfirmation));
